import { Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {MatDialog as MatDialog,MatDialogConfig as MatDialogConfig } from '@angular/material/dialog';
import { AddEditThemeNameComponent } from './add-edit-theme-name/add-edit-theme-name.component';
import { Global } from 'src/app/services/global';
import { AuthService } from 'src/app/services/auth.service';
import { ModuleService } from 'src/app/services/module.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { ToastrService } from 'ngx-toastr';
// import { MediaDialogComponent } from 'src/app/media/media-dialog/media-dialog.component';

@Component({
  selector: 'app-site-themes',
  templateUrl: './site-themes.component.html',
  styleUrls: ['./site-themes.component.css']
})

export class SiteThemesComponent implements OnInit {
  @ViewChild('content', { read: ViewContainerRef,static:true }) content: ViewContainerRef;

  themes: any[] = [];
  selectedTheme: any = {};
  clickedElement: any;
  element: any = 'Site themes';
  templateCss: any = '';

  templateJS: any = '';
  templateImports: any[] = [];

  site: any = {}
  allTemplates: any[] = [];
  templateId: any
  templatestatus: any
  selectedCulture: any = '';
  currentTemplateCss: any = ''
  global: Global;

  options: any = {
    'indent_size': 4,
    'indent_char': ' ',
    'eol': '\n',
    'indent_level': 0,
    'max_preserve_newlines': 10,
    'wrap_line_length': 0,
    'operator_position': 'before-newline',
    'brace_style': 'collapse',
    'indent_scripts': 'normal',
    'indent_with_tabs': true,
    'preserve_newlines': true,
    'end_with_newline': false,
    'editorconfig': false,
    'space_in_paren': false,
    'space_in_empty_paren': false,
    'jslint_happy': false,
    'space_after_anon_function': false,
    'space_after_named_function': false,
    'unindent_chained_methods': false,
    'break_chained_methods': false,
    'keep_array_indentation': true,
    'unescape_strings': false,
    'e4x': false,
    'comma_first': false,
    'eval_code': false,
    'space_before_conditional': true,
    'indent-inner-html': false
  };
  temp: any;
  latestSelectedLayout: any;
  versions: any;
  siteId: string;
  selected: any;
  activeStyle: any = 'Site';
  indexToEdit: number = null;
  tempImports: any = {};
  defaultPage: any;
  js: any = '';
  imports: any[] = [];
  viewGallery: boolean;
  jsScript: boolean = false;
  importFiles: boolean = false;
  cssStyle: boolean = true;
  modalRef: BsModalRef;
  themeToDelete: any = {};

  constructor( private snotifyService: ToastrService, private modalService: BsModalService, private authService: AuthService,
    private httpClient: HttpClient, private dialog: MatDialog, global: Global, private moduleService: ModuleService) {
    this.global = global;
    
  }

  ngOnInit() {
   this.GetThemes();
    this.GetAllTemplates();
    this.siteId = this.authService.siteId
    this.site.css = {};

    this.site.siteCultures = this.authService.siteCultures || []
    this.selectedCulture = this.authService.siteCultures ? this.authService.siteCultures[0] : ''
     this.getSiteDetails(this.siteId)
  }

  getSiteDetails(siteId) {
    this.httpClient.get('/Sites/GetSiteDetails/' + siteId).subscribe((res: any) => {
      this.site.id = siteId
      this.site.Name = res.name ? res.name : ''
      this.site.Description = res.description ? res.description : ''
      this.site.LogoUrl = res.logoUrl ? res.logoUrl : ''
      this.site.HostNames = res.hostName ? res.hostName : []
      this.site.IsDefault = res.isDefault == 1
      this.site.Status = res.status ? res.status : 1
      this.site.siteCultures = res.siteCultures ? res.siteCultures : []
      this.site.css = res.css ? JSON.parse(res.css) : {};
      this.site.settings = res.settings ? JSON.parse(res.settings) : {};
      if (this.site.settings.defaultPage) {
        this.defaultPage = this.site.settings.defaultPage
      }
      if (this.site.settings.script) {
        this.js = this.site.settings.script
      }
      if (this.site.settings.imports) {
        this.imports = this.site.settings.imports
      }

      this.site.HostNames = []
      for (let index = 0; index < res.hostNames.length; index++) {
        const element = res.hostNames[index];
        this.site.HostNames.push({ HostName: element.hostName, CultureCodeId: element.cultureCodeId })
      }
    });
  }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
    timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  GetThemes() {
    this.httpClient.get('/Themes/GetThemes').subscribe((res: any) => {

      console.log('res',res)
      this.themes = res;
      console.log('themes res',this.themes)

       for (let i = 0; i < this.themes.length; i++) {
         if(i==1)
         console.log('hihihh')
         else{
        const theme = this.themes[i];
        theme.classes = theme.classes ? JSON.parse(theme.classes) : []
        theme.colors = theme.colors ? JSON.parse(theme.colors) : []
        theme.fonts = theme.fonts ? JSON.parse(theme.fonts) : []
        if (theme.styles) {
          this.beautify('css')
        }
        theme.styles = theme.styles || ''
        if (theme.scripts) {
          this.beautify('js')
        }
        theme.scripts = theme.scripts || ''
        theme.importFiles = theme.importFiles ? JSON.parse(theme.importFiles) : []

        if ((!this.selectedTheme.id && theme.isActive) || (this.selectedTheme.id == theme.id))
          this.selectedTheme = theme;
      }}

    });
  }
      // for (let i = 0; i < this.themes.length; i++) {
      //   const theme = this.themes[i];
      //   theme.classes = theme.classes ? JSON.parse(theme.classes) : []
      //   theme.colors = theme.colors ? JSON.parse(theme.colors) : []
      //   theme.fonts = theme.fonts ? JSON.parse(theme.fonts) : []
      //   if (theme.styles) {
      //     this.beautify('css')
      //   }
      //   theme.styles = theme.styles || ''
      //   if (theme.scripts) {
      //     this.beautify('js')
      //   }
      //   theme.scripts = theme.scripts || ''
      //   theme.importFiles = theme.importFiles ? JSON.parse(theme.importFiles) : []

      //   if ((!this.selectedTheme.id && theme.isActive) || (this.selectedTheme.id == theme.id))
      //     this.selectedTheme = theme;
      // }
   
  

  saveTheme(id?) {
    var theme = JSON.parse(JSON.stringify(this.selectedTheme));
    theme.classes = JSON.stringify(theme.classes)
    theme.colors = JSON.stringify(theme.colors)
    theme.fonts = JSON.stringify(theme.fonts)
    theme.importFiles = JSON.stringify(theme.importFiles)
    theme.isActive = theme.isActive || false;

    this.httpClient.post('/Themes/SaveTheme/' + theme.id, theme).subscribe((result: any) => {
      this.GetThemes()
      this.openNotifySuccess("Theme saved ")
    });

  }


  addEditThemeName(theme?, id?) {
    var th: any = {};
    console.log('if theme',theme)
    if (theme) {
      th = JSON.parse(JSON.stringify(theme));
      th.classes = JSON.stringify(theme.classes)
      th.colors = JSON.stringify(theme.colors)
      th.fonts = JSON.stringify(theme.fonts)
      th.importFiles = JSON.stringify(theme.importFiles)
    }

    const dialogRef = this.dialog.open(AddEditThemeNameComponent, { data: th });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('result add',result)
        this.httpClient.post('/Themes/SaveTheme/' + (result.id = th.id || 0), result).subscribe((result: any) => {
          console.log('result After add',result)

          this.GetThemes()
          this.openNotifySuccess("Theme saved ")
        });
      }
    });
  }

  deleteTheme() {
    var theme = JSON.parse(JSON.stringify(this.themeToDelete));
    theme.classes = JSON.stringify(theme.classes)
    theme.colors = JSON.stringify(theme.colors)
    theme.fonts = JSON.stringify(theme.fonts)
    theme.importFiles = JSON.stringify(theme.importFiles)
    theme.status = 3;
    this.httpClient.post('/Themes/SaveTheme/' + theme.id, theme).subscribe((result: any) => {
      this.GetThemes()
      this.modalRef.hide();
      this.snotifyService.error("Theme is deleted", "", {
        timeOut: 2000,
        progressBar: true,
        tapToDismiss: true,
      });

    });
  }

  openDeleteModal(template: TemplateRef<any>, theme) {
    this.modalRef = this.modalService.show(template);
    this.themeToDelete = theme
  }

  duplicateTheme(orgtheme) {

    var theme = JSON.parse(JSON.stringify(orgtheme));
    theme.status = 1;
    theme.id = 0;
    this.addEditThemeName(theme, theme.id)
    // this.saveTheme()
    // this.openSnackBar("Theme duplicated ")

  }

  SetActiveTheme(theme) {
    this.httpClient.post('/Themes/SetActiveTheme/' + theme.id, {}).subscribe((result: any) => {
      this.openNotifySuccess("Theme Activated ");
      this.GetThemes();
    });
  }

  AddImports() {
    if (this.indexToEdit == null)
      this.templateImports.push(this.tempImports);
    else
      this.templateImports[this.indexToEdit] = JSON.parse(JSON.stringify(this.tempImports))
    this.indexToEdit = null;
    this.tempImports = {}
  }

  editImports(data, i) {
    this.tempImports = JSON.parse(JSON.stringify(data));
    this.indexToEdit = i;
  }

  del(c, i) {
    this.templateImports.splice(i, 1);
  }

  GetAllTemplates() {
    this.httpClient.get('/PageTemplate/GetAllPageTemplates').subscribe((res: any) => {
      this.allTemplates = res;
      this.templateId = this.allTemplates.length > 0 ? this.allTemplates[0].id : 0
      this.GetTemplateData(this.templateId)
    });
  }

  GetTemplateData(id) {
    this.httpClient.get(`/PageTemplate/GetPageTemplatesById/${id}`).subscribe((template: any) => {
      // this.temp = template;     

      this.templateCss = template.currentVersion.css || '';
      this.templateJS = template.currentVersion.scripts || '';
      this.templateImports = template.currentVersion.importFiles ? JSON.parse(template.currentVersion.importFiles) : []


    });
  }

  saveTemplate() {

    var data = {
      TemplateId: Number(this.templateId),
      Css: this.templateCss || '',
      Scripts: this.templateJS || '',
      ImportFiles: JSON.stringify(this.templateImports),
    }
    this.httpClient.post('/PageTemplate/SetTemplateData', data).subscribe((res: any) => {
      this.openNotifySuccess("Template styles saved")
    });
  }



  saveCulture() {
    const data = {
      css: JSON.stringify(this.site.css)
    }

    this.httpClient.post('/Sites/SetSiteCSS', data).subscribe((result: any) => {
      this.openNotifySuccess("Style saved")

    });

  }

  editSite() {
    this.site.settings = { defaultPage: this.defaultPage, script: this.js, imports: this.imports }

    const data = {
      SiteId: this.authService.siteId,
      Name: this.site.Name,
      Description: this.site.Description,
      LogoUrl: this.site.LogoUrl,
      HostNames: this.site.HostNames,
      IsDefault: this.site.IsDefault ? 1 : 0,
      Status: 1,
      css: JSON.stringify(this.site.css),
      Settings: JSON.stringify(this.site.settings)
    }
    this.httpClient.post('/Sites/EditSite', data).subscribe((result: any) => {
      this.openNotifySuccess("saved success")
    });




  }

  openGallery() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { top: "0px", right: "0px" };
    dialogConfig.height = "100vh";
    dialogConfig.width = "50vw";
    dialogConfig.panelClass = "media-modal";
    dialogConfig.data = {isMultiSelect: false ,files: ["image",'webp'] };
 
    // let dialogRef = this.dialog.open(MediaDialogComponent, dialogConfig);
    // dialogRef.afterClosed().subscribe((result) => {
    //   if (result) {
    //   //  this.tempMenu.thumbnailId = result.id;
    //     this.tempImports.link = result.publicUrl;
    //   }
    // });
  }

  // openGalery() {

  //   var x = this.moduleService.ComponentFactory['GalleryComponent'];
  //   if (this.moduleService.ComponentFactory['GalleryComponent']) {
  //     this.viewGallery = true
  //     this.content.clear();
  //     // create setting component
  //     const component: any = this.content.createComponent(x);
  //     // sending @Input() values 
  //     component.instance.data = { enviroment: window['config'] };
  //     //  save @output() 
  //     component.instance.imgUrl.subscribe(res => {
  //       if (res && res != null) {
  //         this.tempImports.link = window['config'].apiUrl + '/' + res.publicUrl
  //         while (this.tempImports.link.indexOf('\\') !== -1) {
  //           this.tempImports.link = this.tempImports.link.replace('\\', '/');
  //         }

  //       }
  //       this.viewGallery = false
  //       this.content.clear();
  //     });
  //   }

  // }

  beautify(type) {
    if (type == 'css') {
      this.options['indent_size'] = 1;
      this.selectedTheme.styles = this.global.beautify[type](this.selectedTheme.styles, this.options);
    }
    else {
      this.options['indent_size'] = 4;
      this.selectedTheme.scripts = this.global.beautify[type](this.selectedTheme.scripts, this.options);
    }
  }


  openImportsTabs(type) {
    if (type == 'css') {
      this.cssStyle = true
      this.jsScript = false
      this.importFiles = false
    }
    else if (type == 'js') {
      this.cssStyle = false
      this.jsScript = true
      this.importFiles = false
    }
    else {
      this.cssStyle = false
      this.jsScript = false
      this.importFiles = true
    }
  }


}
